var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShipping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "49px",
    viewBox: "0 0 56 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Envio") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home_V1",
    transform: "translate(-612.000000, -5452.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer",
    transform: "translate(0.000000, 5370.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-41",
    transform: "translate(498.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Envio",
    transform: "translate(115.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-193",
    stroke: "#484848",
    strokeWidth: 1.3824,
    x: 1.8189894e-12,
    y: 1,
    width: 54,
    height: 9.72151899,
    rx: 1.8432
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,10.721519 L51.0909091,10.721519 L51.0909091,47.0485209 L51.0909091,47.0485209 C51.0909091,47.7271684 50.5407566,48.2773209 49.8621091,48.2773209 L3.2288,48.2773209 L3.2288,48.2773209 C2.5501525,48.2773209 2,47.7271684 2,47.0485209 L2,10.721519 Z",
    id: "Rectangle-194",
    stroke: "#484848",
    strokeWidth: 1.3824
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#4E89E5",
    points: "22 21.5201843 23.6365603 19.8694974 25.2726781 21.5201843 26.9090909 19.8694974 28.5453562 21.5201843 30.1819165 19.8694974 31.8181818 21.5201843 31.8181818 10 22 10"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-195",
    fill: "#4C8CF1",
    x: 22,
    y: 0.299804688,
    width: 9.81818182,
    height: 10.4217143
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(7.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8725507,10.9474993 L0.45479263,10.9474993 C0.203662552,10.9474993 0,10.7315727 0,10.4657 L0,0.482179177 C0,0.215926634 0.203662552,0 0.45479263,0 L18.8725507,0 C19.1236808,0 19.3271642,0.215926634 19.3271642,0.482179177 L19.3271642,10.4657 C19.3271642,10.7315727 19.1236808,10.9474993 18.8725507,10.9474993",
    id: "Fill-15",
    stroke: "#484848",
    strokeWidth: 1.2288,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54718671,5.5806852 C4.26884737,5.5806852 4.02089163,5.45332796 3.85941232,5.25346535 C3.73894025,5.10467174 3.66669951,4.91573747 3.66669951,4.70978021 C3.66669951,4.22872289 4.06083651,3.83908538 4.54718671,3.83908538 C5.0335369,3.83908538 5.4276739,4.22872289 5.4276739,4.70978021 C5.4276739,5.19104769 5.0335369,5.5806852 4.54718671,5.5806852 M4.54718671,2.43037975 C3.27447476,2.43037975 2.24249447,3.45091899 2.24249447,4.70978021 C2.24249447,5.17129261 2.3874009,5.59623708 2.62579536,5.95540132 L4.54718671,8.50632911 L6.47431481,5.95540132 C6.71143444,5.59686756 6.85166647,5.17003164 6.85166647,4.70978021 C6.85166647,3.45091899 5.82011113,2.43037975 4.54718671,2.43037975",
    id: "Fill-16",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19850403,3.64556962 L15.3469505,3.64556962 L15.3469505,3.64556962 C15.6825159,3.64556962 15.9545455,3.3735401 15.9545455,3.03797468 L15.9545455,3.03797468 L15.9545455,3.03797468 C15.9545455,2.70240927 15.6825159,2.43037975 15.3469505,2.43037975 L9.19850403,2.43037975 L9.19850403,2.43037975 C8.86293861,2.43037975 8.59090909,2.70240927 8.59090909,3.03797468 L8.59090909,3.03797468 L8.59090909,3.03797468 C8.59090909,3.3735401 8.86293861,3.64556962 9.19850403,3.64556962 Z",
    id: "Fill-17",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19850403,6.07594937 L13.5060414,6.07594937 L13.5060414,6.07594937 C13.8416068,6.07594937 14.1136364,5.80391985 14.1136364,5.46835443 L14.1136364,5.46835443 L14.1136364,5.46835443 C14.1136364,5.13278901 13.8416068,4.86075949 13.5060414,4.86075949 L9.19850403,4.86075949 L9.19850403,4.86075949 C8.86293861,4.86075949 8.59090909,5.13278901 8.59090909,5.46835443 L8.59090909,5.46835443 L8.59090909,5.46835443 C8.59090909,5.80391985 8.86293861,6.07594937 9.19850403,6.07594937 Z",
    id: "Fill-18",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19850403,8.50632911 L14.1196778,8.50632911 L14.1196778,8.50632911 C14.4552432,8.50632911 14.7272727,8.23429959 14.7272727,7.89873418 L14.7272727,7.89873418 L14.7272727,7.89873418 C14.7272727,7.56316876 14.4552432,7.29113924 14.1196778,7.29113924 L9.19850403,7.29113924 L9.19850403,7.29113924 C8.86293861,7.29113924 8.59090909,7.56316876 8.59090909,7.89873418 L8.59090909,7.89873418 L8.59090909,7.89873418 C8.59090909,8.23429959 8.86293861,8.50632911 9.19850403,8.50632911 Z",
    id: "Fill-19",
    fill: "#484848"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.31d57297b3765c934185bfe113ad154a.svg";
export { ForwardRef as ReactComponent };